// The table's room, as a reflection map. A warm dark room gives every
// MeshStandardMaterial subtle ambient reflections without an external HDR:
// cards, tokens, dice and the table surface all pick up the same soft light.
// Shared by the board and the dice tray, so a die in the tray reflects the
// room it will be dropped into.
import * as THREE from 'three';

export function buildTableEnvironment(renderer) {
  const envScene = new THREE.Scene();
  const envGeo = new THREE.SphereGeometry(50, 16, 16);
  const envMat = new THREE.MeshBasicMaterial({ color: 0x221810, side: THREE.BackSide });
  envScene.add(new THREE.Mesh(envGeo, envMat));
  const warmLight = new THREE.PointLight(0xffa54f, 1.5, 100);
  warmLight.position.set(0, 10, 0);
  envScene.add(warmLight);
  // Second fill light for richer, more varied reflections on PBR surfaces
  const fillLight = new THREE.PointLight(0xcc9966, 0.8, 80);
  fillLight.position.set(-15, 5, 10);
  envScene.add(fillLight);
  const pmrem = new THREE.PMREMGenerator(renderer);
  const texture = pmrem.fromScene(envScene, 0.04).texture;
  pmrem.dispose();
  envGeo.dispose();
  envMat.dispose();
  return texture;
}
